enum IMAGE_TYPE {
    SVG,
    CUSTOM,
}
interface IIconInfo {
    iconType: IMAGE_TYPE;
    iconName: string;
    activeIconName?: string;
    normalIcon: string;
    activeIcon: string;
    svgUrl?: string;
    activeSvgUrl?: string;
    color: string;
    normalColor?: string;
}
interface IIconItemInfo {
    iconName: string;
    activeIconName?: string;
    desc?: string;
    remark?: string;
    url?: string;
    activeUrl?: string;
}
interface IColorConfig {
    restColor?: string;
    isAllowRest?: boolean;
    restText?: string;
    title?: string | JSX.Element;
    prefixText?: string;
}
export { IMAGE_TYPE, IIconInfo, IIconItemInfo, IColorConfig };
